import type { ReactNode } from "react"

interface InventoryLotListCellProps<T> {
  lots: T[] | null | undefined
  getKey: (lot: T) => string
  render: (lot: T) => ReactNode
}

export const InventoryLotListCell = <T,>({ lots, getKey, render }: InventoryLotListCellProps<T>): ReactNode => (
  <div className='flex flex-col gap-y-1'>
    {(lots ?? []).map((lot) => (
      <div key={getKey(lot)} className='min-h-[1lh] whitespace-nowrap'>
        {render(lot)}
      </div>
    ))}
  </div>
)
